export const mountableSteps = {
	title: "Mountable product",
	description:
		"Mountable products allow the end customer to create a combination from a fixed base and a variety of additional ingredients. In the case of açaí, for example, the base would be blended açaí and the additional ingredients would be peanut brittle, milk powder, etc.",
	stepLabel: "Step",
	addStep: "Step",
	removeStep: "Remove step",
	fields: {
		title: {
			label: "Title",
			placeholder: "Enter the step title",
		},
		pricing: {
			label: "Pricing",
			placeholder: "Choose a method",
			options: {
				sum: {
					label: "Additional",
					tooltip: "Every item added will be incremented in the product value",
				},
				average: {
					label: "Average",
					tooltip: "The average of selected items will be incremented",
				},
				higher: {
					label: "Highest value",
					tooltip: "The highest value among items will be added to the product value",
				},
			},
		},
		min: {
			label: "Minimum value",
			tooltip: "Minimum items to be selected",
		},
		max: {
			label: "Maximum value",
			tooltip: "Maximum items to be selected",
		},
	},
	fiscalSplit: {
		enabled: "Fiscal split enabled",
		disabled: "Fiscal split disabled",
		title: "FISCAL SPLIT",
		fiscalWeight: {
			label: "% Fiscal weight of step {{stepNumber}}",
			placeholder: "00%",
			info: "The weight (%) determines how much this step represents on the invoice.",
			supplyAlert: {
				title: "There are some supplies in this step",
				message:
					"When the step has both products and supplies, the fiscal weight (%) only defines the participation of products with fiscal data on the invoice. The supplies above do not have fiscal data and will not be issued.",
			},
		},
		summary: {
			title: "Fiscal summary",
			stepPrefix: "Step",
			incomplete: "distribute 100% across the steps",
		},
		dialog: {
			triggerLabel: "Learn more about fiscal split",
			title: "Fiscal split",
			paragraph1:
				"The fiscal split defines how the total invoice amount is distributed across the items of the mountable product.",
			paragraph2: {
				intro:
					"The weights (%) of the steps determine the share of products with fiscal data on the invoice.",
				bold: "Supplies do not have fiscal data and will not be issued on the final invoice.",
			},
			example: {
				title: "Example:",
				intro: "A R$ 20 caipirinha:",
				item1: "Base (70%) — cachaça (product with fiscal data): R$ 14",
				item2:
					"Complements (30%) — sugar (supply) and lime (supply): not issued",
				conclusion:
					"In this case, only the cachaça participates in the invoice value split.",
			},
			close: "Close",
			confirm: "Got it",
		},
	},
	itemsSection: {
		title: "ADDITIONAL INGREDIENTS",
		addItem: "Add another item",
		removeItem: "Remove item",
		fields: {
			item: {
				label: "Item",
				placeholder: "Select an item",
				loadingPlaceholder: "Loading products...",
			},
			price: {
				label: "Price",
			},
			maxCount: {
				label: "Maximum selectable quantity",
				placeholder: "Enter quantity",
				tooltip: "Maximum number of times this item can be selected in the section",
			},
			storageCount: {
				label: "Deducted quantity",
				placeholder: "0",
				tooltip: "Quantity to be deducted from stock per unit",
			},
			isModification: {
				label: "Modification item",
			},
		},
	},
};
